import React, { FC } from 'react';
import { CategoriesPanelType } from '../../../models/categories-panel-type';
import { CategoryType } from '../../../models/category-type';
import CategoryCard from '../../molecules/category-card/category-card';

const CategoriesPanel: FC<CategoriesPanelType> = ({
  categories,
}: CategoriesPanelType) => (
  <div className="py-component-spacing-mobile lg:py-component-spacing">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {categories.map((category: CategoryType, index: number) => (
        <CategoryCard key={category.name} {...category} index={index} isPanel />
      ))}
    </div>
  </div>
);

export default CategoriesPanel;
